import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestModels_Usages_Estimate_AddressCharacteristicsRequestModel,
  ResponseModels_Customers_Address_AddressBusinessCheckResponse,
  ResponseModels_Customers_Address_AddressModel,
  ResponseModels_Usages_Estimate_AddressCharacteristicsResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetAddressPublic = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  postalCode: string;
  houseNumber: string;
  houseNumberSuffix?: string;
  addServiceLocationId?: boolean;
};
/**
 * Return a complete address, or an address with possible house number suffixes
 *
 * @returns ResponseModels_Customers_Address_AddressModel Success
 */
export function getAddressPublic(
  { businessUnit, label, postalCode, houseNumber, houseNumberSuffix, addServiceLocationId }: GetAddressPublic,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Customers_Address_AddressModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/public/${businessUnit}/${label}/address`,
      query: { postalCode, houseNumber, houseNumberSuffix, addServiceLocationId },
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}

type GetAddressCharacteristics = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody: RequestModels_Usages_Estimate_AddressCharacteristicsRequestModel;
};
/**
 * Looks up the building characteristics of an address so the funnel can prefill the estimate
questions. Best effort: fields are null when they are not known or the lookup fails.
 * 
 * @returns ResponseModels_Usages_Estimate_AddressCharacteristicsResponseModel Success
 */
export function getAddressCharacteristics(
  { businessUnit, label, requestBody }: GetAddressCharacteristics,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Usages_Estimate_AddressCharacteristicsResponseModel> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/public/${businessUnit}/${label}/address-characteristics`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type GetAddressBusinessCheck = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  postalCode: string;
  houseNumber: number;
  houseNumberSuffix?: string;
};
/**
 * Checks whether there is a large business located at a certain address
 *
 * @returns ResponseModels_Customers_Address_AddressBusinessCheckResponse Success
 */
export function getAddressBusinessCheck(
  { businessUnit, label, postalCode, houseNumber, houseNumberSuffix }: GetAddressBusinessCheck,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Customers_Address_AddressBusinessCheckResponse> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/public/${businessUnit}/${label}/addressbusinesscheck`,
      query: { postalCode, houseNumber, houseNumberSuffix },
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}
